module.exports = __webpack_public_path__ + "static/media/balance.42c68879.png";